<template>
    <div class="pixabay-browser pa-4">
        <loading :loading="loading && !disableLoadingSpinner"/>

        <pixabay-search-input v-model="query" @search="performSearch"/>

        <pixabay-info-text :images="images" :loading="loading" :has-searched="hasSearched"/>

        <div class="masonry-scroll" ref="scrollContainer">
            <masonry-wall
                :items="images"
                :gap="12"
                :scroll-container="scrollContainerEl"
            >
                <template v-slot="{ item }">
                    <pixabay-image-preview
                        :image="item"
                        :selected="isSelected(item)"
                        @click="select"
                    />
                </template>
            </masonry-wall>
        </div>
    </div>
</template>

<script>
import {PixabayImage} from "./PixabayImage";
import {pixabaySearchService} from "./PixabaySearchService";
import Loading from "../common/loading.vue";
import PixabayInfoText from "./PixabayInfoText.vue";
import PixabaySearchInput from "./PixabaySearchInput.vue";
import PixabayImagePreview from "./PixabayImagePreview.vue";

export default {
    name: "PixabayImageBrowser",
    components: {PixabayImagePreview, PixabaySearchInput, PixabayInfoText, Loading},
    props: {
        disableLoadingSpinner: {type: Boolean, default: false},
        multiple: {type: Boolean, default: false},
        preload: {type: Boolean, default: false}
    },
    data() {
        return {
            scrollContainerEl: null,
            selectedIds: [],
            /** @type{PixabaySearchService} */
            service: pixabaySearchService
        };
    },
    computed: {
        /** @type {PixabayImage[]} */
        images() {
            return this.service.images;
        },
        loading() {
            return this.service.loading;
        },
        totalHits() {
            return this.service.totalHits;
        },
        query: {
            get() {
                return this.service.query;
            },
            set(val) {
                this.service.setQuery(val);
            },
        },
        hasSearched() {
            return this.service.hasSearched;
        },
        selectedImages() {
            const allPages = Object.values(this.service.pageCache || {}).flat();
            return allPages.filter(img => this.selectedIds.includes(img.id));
        }
    },
    methods: {
        async performSearch() {
            this.service.pageCache = {};
            this.selectedIds = [];
            this.emitSelectedImages();
            await this.service.search();
        },
        select(photo) {
            const id = photo.id;

            if (this.multiple) {
                const index = this.selectedIds.indexOf(id);
                if (index >= 0) this.selectedIds.splice(index, 1);
                else this.selectedIds.push(id);
            } else {
                this.selectedIds = [id];
            }

            this.emitSelectedImages();
        },
        emitSelectedImages() {
            const allPages = Object.values(this.service.pageCache || {}).flat();
            const images = allPages.filter(img => this.selectedIds.includes(img.id));
            this.$emit("update:selected", images);
        },
        isSelected(img) {
            return this.selectedIds.includes(img.id);
        }
    },
    async mounted() {
        this.scrollContainerEl = this.$refs.scrollContainer;

        if (this.preload) {
            this.service.setQuery('');
            this.service.setProperty('editors_choice', true);
            await this.service.search();
        }
    }
};
</script>

<style scoped>
.pixabay-browser {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.masonry-scroll {
    overflow-y: auto;
    padding: 4px;
    margin-top: 12px;
}
</style>
